import { faChevronRight } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Breadcrumbs as MuiBreadcrumbs, Button, Box, styled, useTheme, ButtonProps } from "@mui/material";
import { NavLink } from "react-router-dom";
import React from "react";
import { useBreadcrumbs } from "@/contexts/layout/BreadcrumbContext";
import AppSettings from "@/AppSettings";

const StyledBreadcrumbs = styled(MuiBreadcrumbs)(({ theme }) => ({
    color: "#585a5b",
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0.5, 3),
    width: "100%",
    margin: "0 auto",

    ...theme.applyStyles?.("dark", {
        color: "rgba(255, 255, 255, 0.7)"
    })
}));


const StyledButton = styled(Button)<ButtonProps>(({ theme }) => ({
    borderRadius: 50,
    fontSize: "0.75rem",
    fontWeight: 500,
    textTransform: "none",
    margin: theme.spacing(0.25, 0)
}));

const BreadcrumbContainer: React.FC = () => {

    const theme = useTheme();

    const { breadcrumbs } = useBreadcrumbs();

    if (!breadcrumbs.length) return null;

    return (
        <Box
        sx={{
            width: "100%",
            backgroundColor: theme.palette.mode === 'dark' ? AppSettings.palette.breadcrumbBgDark : AppSettings.palette.breadcrumbBgLight,
        }}
        >
            <Box
                sx={{
                    maxWidth: '1280px',
                    width: '100%',
                    margin: '0 auto',
                }}
            >
                <StyledBreadcrumbs separator={<FontAwesomeIcon icon={faChevronRight} fixedWidth />}>
                    {breadcrumbs.map((breadcrumb, i) => (
                    <StyledButton
                        key={i}
                        component={NavLink}
                        color="inherit"
                        startIcon={
                        breadcrumb.icon ? <FontAwesomeIcon icon={breadcrumb.icon} fixedWidth /> : undefined
                        }
                        size="small"
                        disableRipple
                        {...{ to: breadcrumb.to }} // navlink
                    >
                        {breadcrumb.label}
                    </StyledButton>
                    ))}
                </StyledBreadcrumbs>
            </Box>
        </Box>
    );
};

export default BreadcrumbContainer;
